export default {
explore_by: "εξερεύνηση ανά",
explore_by_concepts: "ιδέες",
explore_by_families: "οικογένειες αρωμάτων",
language: "γλώσσα",
legal: "νομικά",
find_any_fragrance: "βρείτε οποιοδήποτε άρωμα στον κόσμο.",
title_by_concepts: "εξερεύνηση με ιδέες",
desc_by_concepts: "βρες το άρωμά σου σκεπτόμενος το αγαπημένο σου χρώμα ή μέρος",
title_by_families: "εξερεύνηση ανά οικογένειες",
desc_by_families: "βρες το άρωμά σου σκεπτόμενος ...",
expert_reviewed: "ελεγμένο από ειδικούς",
ingredients: "συστατικά",
description: "περιγραφή",
perfumist: "αρωματοποιός",
concepts: "έννοιες",
olfactive_family: "οσφρητική οικογένεια",
main_family: "οικογένεια",
sub_family: "υποοικογένεια",
me_family: "Αρώματα του Κόσμου",
filter_by_family: "οικογένειες",
filter_by_brand: "μάρκες",
filter_by_gender: "φύλο",
for_him: "για εκείνον",
for_her: "για εκείνη",
unisex: "unisex",
all: "όλα",
all_female: "όλα",
concepts_list: "λίστα εννοιών",
no_results_for_this_combination: "δεν υπάρχουν αρώματα για αυτόν τον συνδυασμό.",
select_at_least_one_concept: "επίλεξε τουλάχιστον μία έννοια",
view_perfumes: "προβολή αρωμάτων",
back: "πίσω",
close: "κλείσιμο",
filters: "φίλτρα",
selected_concepts: "επιλεγμένες έννοιες:",
selected_families: "επιλεγμένες οικογένειες:",
find_concept: "βρες έννοιες...",
smell_of: "μυρωδιά από",
touch_of: "με μια νότα από",
loading_perfumes: "φόρτωση αρωμάτων",
loading_concepts: "φόρτωση εννοιών",
apply: "εφαρμογή",
search: "αναζήτηση",
clear_all: "εκκαθάριση όλων",
iconic_fragrances: "εμβληματικά αρώματα σε αυτή την οικογένεια",
is_there_anybody_here: "είσαι ακόμα εδώ;",
continue_previous_session: "ναι! ας συνεχίσουμε",
reset_session: "επανεκκίνηση της εμπειρίας",
ingredient_type: "τύπος",
ingredient_parts: "μέρη που χρησιμοποιούνται",
ingredient_extraction: "μέθοδος εκχύλισης",
ingredient_first: "εμβληματικό άρωμα",
history: "ιστορία",
effect: "παραγωγή και αποτέλεσμα",
origin: "προέλευση",
iconic_fragrance: "εμβληματικό άρωμα",
production: "παραγωγή",
loyalty_become_a_member: "Γίνετε μέλος του Club",
loyalty_avolta_link: "https://qr.clubavolta.com/register?source=ctOffline-scDuty_Free-sgAirport&campaign=Fragrance_Finder_Tools"   
}